import React, { Component } from 'react'

import Background from '../components/Background'
import Uploader from '../components/Uploader'


export default class HomePage extends Component {
  render() {
    return (
      <div className="landing">
        <Background />
        <div key="home-main" className="container-fluid">
          <div className="row">
            <Uploader history={this.props.history} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/HomePage.js